
import { Observer } from 'mobx-vue'
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import LazyImg from '@/components/lazyImg/index.vue'
import Qrcode from '@xt/www/components/showQrcode/index.vue'
import { $service } from '@xt/client/experimental/request/service'
import { EnumApiProduct } from '@xt/client/api'

// 弹窗组件数据类型
type Wenfang = {
  id: number
  appletUrl: string
  toolName: string
  description: string
  request?: boolean
  productList?: Array<ProductToolList>
}

// 关联文房商品展示数据类型
type WenfangProductList = Array<{
  id: number
  title: string
  cover: string
  jumpUrl: string
  actualQuantity: number
  alias: string
  show?: boolean
}>

// 关联文房商品接口数据类型
type ProductToolList = {
  actualQuantity: number
  coverUrl: string
  id: number
  pageUrl: string
  productName: string
  alias: string
}

@Observer
@Component({
  components: {
    LazyImg,
    Qrcode
  }
})
export default class NewWfDetailPop extends Vue {
  @Prop({ type: Boolean, default: false }) visible: boolean
  @Prop() wfData: Wenfang

  productList: WenfangProductList = []

  onMouseEnter(index: number) {
    if (this.productList[index].show === true) return

    this.productList[index].show = true
  }

  onMouseLeave(index: number) {
    if (this.productList[index].show === false) return

    this.productList[index].show = false
  }

  getPopupContainerNode(triggerNode: HTMLElement) {
    return triggerNode.parentNode ?? (document.body as HTMLElement)
  }

  // 重置数据
  onReset() {
    this.productList = []
  }

  @Emit('close')
  onClose(): void {}

  @Watch('visible')
  async visibleChange(val) {
    if (!val) {
      this.onReset()
      return
    }

    // 兼容请求情况
    if (this.wfData.request === true) {
      // 根据文房装备查询文房商品列表
      const [error, data] = await $service<Array<ProductToolList>>({
        url: EnumApiProduct.wenfangProductList,
        method: 'GET',
        params: {
          toolId: this.wfData.id
        },
        data: {
          toolId: this.wfData.id
        }
      })

      if (error) return

      this.productList = data.map(item => {
        return {
          id: item.id,
          title: item.productName,
          cover: item.coverUrl,
          jumpUrl: item.pageUrl,
          actualQuantity: item.actualQuantity,
          alias: item.alias,
          show: false
        }
      })

      return
    }

    // 配置productList存在，直接赋值；
    if (Array.isArray(this.wfData.productList)) {
      this.productList = this.wfData.productList.map(item => {
        return {
          id: item.id,
          title: item.productName,
          cover: item.coverUrl,
          jumpUrl: item.pageUrl,
          actualQuantity: item.actualQuantity,
          alias: item.alias,
          show: false
        }
      })
    }
  }

  created() {}

  destroy(): void {}
}
